export default __webpack_public_path__ + "assets/front/scss/classification-browsing.bb3fb414fb8031e2ec2f1132684e7d2e.css";